module.exports = __webpack_public_path__ + "img/tu7.a7e37d81.png";